<template>
  <!-- Cart Payment Summary -->
  <div data-cy="cart-payment-summary" class="w-full flex pb-8 flex-col items-center justify-center md:justify-start">
    <PaymentSummary
      :total="total"
      :subtotal="subtotal"
      :discounts="discounts"
      :shipping-fees="shippingFees"
      class="w-full"
      inverted
    >
      <template #cta-placeholder>
        <div class="md:mt-5 px-5 flex flex-col items-center justify-center">
          <AppButton
            data-cy="go-to-checkout"
            as="AppLink"
            :to="isLoggedIn ? '/checkout/shipping' : '/login?checkout=true'"
            class="ProceedBtn mt-6 block w-full font-medium uppercase"
            :disabled="hasInvalidItems"
            disable-hover
            inverted
          >
            {{ $t('proceed') }}
          </AppButton>
          <p v-if="!isLoggedIn" class="flex gap-2 mt-6">
            <svg-icon-error-black width="24" height="24" />
            <span>{{ $t('loginToUseloyaltyPoints') }}</span>
          </p>

          <p v-if="hasInvalidItems" class="hidden md:flex gap-x-1 items-center mt-1 ml-2 mr-auto">
            <svg-icon-error class="w-3 h-4 z-20 text-red-700" />
            <span class="text-red-700 text-base">{{ $t('invalidItemsError') }}</span>
          </p>
        </div>
      </template>
    </PaymentSummary>
    <AppLink to="/" class="mx-auto mt-8 text-base underline text-primary-1-100">
      {{ $t('continueShopping') }}
    </AppLink>
  </div>
</template>

<script setup lang="ts">
defineComponent({
  name: 'CartPaymentSummary',
});
const { t: $t } = useI18n({
  useScope: 'local',
});
const { isLoggedIn } = useAuth();
const { total, subtotal, shippingFees, discounts } = useCartAttributes();

const { hasInvalidItems } = useExtendedCartAttributes();
</script>

<style lang="postcss" scoped>
.ProceedBtn {
  display: none;

  @screen md {
    display: flex;
  }
}
</style>

<i18n>
{
  "en": {
    "summary": "Payment Summary",
    "subtotal": "Subtotal",
    "total": "Total",
    "shippingFees": "Shipping Fees",
    "taxesIncluded": "All taxes are included",
    "proceed": "Proceed to checkout",
    "toBeCalculated": "To Be Calculated",
    "continueShopping": "Back to Continue Shopping",
    "invalidItemsError": "Please remove out of stock items from cart.",
    "loginToUseloyaltyPoints": "Make sure to log in or create an account to access your loyalty points."
  },
  "ar": {
    "summary": "تفاصيل الطلب",
    "subtotal": "الاجمالي الفرعي",
    "total": "الاجمالي",
    "shippingFees": "مصاريف الشحن",
    "taxesIncluded": "يشمل قيمه الضرائب",
    "toBeCalculated": "سيتم حسابها لاحقا",
    "continueShopping": "استمر فى التسوق",
    "proceed": "استمر للدفع",
    "invalidItemsError": "يرجي حذف المنتجات الغير متاحة من العربة.",
    "loginToUseloyaltyPoints": "تأكد من تسجيل الدخول أو إنشاء حساب للوصول إلى نقاط الولاء الخاصة بك."

  }
}
</i18n>
